

const nodeStyles = () => {
const IFNodeStyle = {
    background: 'gray',
    color: 'purple',
    border: '1px solid #222138',
    textAlign: 'center',
    width: 600,
  };

  const LoopNodeStyle = {
    background: 'marble',
    color: 'purple',
    border: '1px solid #222138',
    width: 600,
  };

  const RegularNodeStyle = {
    background: 'brown',
    color: 'yellow',
    border: '1px solid #222138',
    textAlign: 'center',
    width: 600,
  };

  const WaitNodeStyle = {
    background: 'orange',
    color: 'red',
    border: '1px solid #222138',
    textAlign: 'center',
    width: 600,
  };


const BizNodeStyle = {
    background: 'skyblue',
    color: 'purple',
    border: '1px solid #222138',
    width: 600,
  };


}

export default nodeStyles;